<div mat-dialog-content>
    <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button color="accent" (click)="clickConfirm()">Confirmar</button>
    <button mat-button color="primary" (click)="clickReject()">Cancelar</button>
</div>